var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCost = function SvgCost(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D42A36",
    d: "M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.5 14.18a11 11 0 0 1-1.657-.161 7 7 0 0 1-1.329-.404v-1.737q.585.27 1.415.498a8 8 0 0 0 1.571.256V10.6a17 17 0 0 1-1.414-.592 4.4 4.4 0 0 1-.929-.593 2.05 2.05 0 0 1-.5-.7 2.4 2.4 0 0 1-.157-.888q0-.674.371-1.158.387-.498 1.058-.795A4.9 4.9 0 0 1 9.5 5.51V4.5h.957v.983a8.7 8.7 0 0 1 1.5.175q.714.148 1.386.43l-.657 1.536a7 7 0 0 0-1.157-.35 8.5 8.5 0 0 0-1.072-.162v1.939q.771.27 1.472.592.699.31 1.128.795.443.485.443 1.279 0 .982-.757 1.642t-2.286.795V15.5H9.5zm.957-1.588q.486-.081.714-.27a.65.65 0 0 0 .229-.511.48.48 0 0 0-.114-.323.9.9 0 0 0-.315-.27 3 3 0 0 0-.514-.269zM9.5 7.139a1.7 1.7 0 0 0-.486.135.73.73 0 0 0-.314.228.53.53 0 0 0-.1.324.66.66 0 0 0 .086.336q.099.135.3.27.2.12.514.255z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCost);
export default ForwardRef;